import { useTranslation } from "react-i18next";
import { Theme } from "../../../api/types";
import CartSvg from "./ScratchCardCartSvg";
import React from "react";

import {
    SelectCheckoutTypeButton,
    SubscriptionBoxTitle,
    SubscriptionBoxText,
} from "./ScratchcardWrapper.styled";

export function OneTimePurchaseButton(props: {
    onClick: () => void;
    theme: Theme;
    disabled?: boolean;
}) {
    const { t } = useTranslation();
    return (
        <SelectCheckoutTypeButton
            type="button"
            onClick={() => props.onClick()}
            disabled={props.disabled}
        >
            <div>
                <CartSvg theme={props.theme} />
            </div>
            <SubscriptionBoxTitle>
                {t("one_time_purchase_title")}
            </SubscriptionBoxTitle>
            <SubscriptionBoxText>
                {t("one_time_purchase_text")}
            </SubscriptionBoxText>
        </SelectCheckoutTypeButton>
    );
}
